"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Postcodes = void 0;
const postcodesGetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGet_js_1 = require("../funcs/postcodesGetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGet.js");
const postcodesGetPostcodeAddressesPostcodesPostcodePropertiesGet_js_1 = require("../funcs/postcodesGetPostcodeAddressesPostcodesPostcodePropertiesGet.js");
const postcodesGetPostcodeLocationPostcodesPostcodeLocationGet_js_1 = require("../funcs/postcodesGetPostcodeLocationPostcodesPostcodeLocationGet.js");
const postcodesGetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGet_js_1 = require("../funcs/postcodesGetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Postcodes extends sdks_js_1.ClientSDK {
    /**
     * Get Energy Performance Certificates
     *
     * @remarks
     * Get all active epcs for a given postcode.
     */
    async getEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, postcodesGetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGet_js_1.postcodesGetEnergyPerformanceCertificatesPostcodesPostcodeEnergyPerformanceCertificatesGet)(this, security, request, options));
    }
    /**
     * Get Postcode Addresses
     *
     * @remarks
     * Get addresses for properties in a postcode.
     */
    async getPostcodeAddressesPostcodesPostcodePropertiesGet(security, postcode, options) {
        return (0, fp_js_1.unwrapAsync)((0, postcodesGetPostcodeAddressesPostcodesPostcodePropertiesGet_js_1.postcodesGetPostcodeAddressesPostcodesPostcodePropertiesGet)(this, security, postcode, options));
    }
    /**
     * Get Postcode Location
     *
     * @remarks
     * Get location of postcode.
     */
    async getPostcodeLocationPostcodesPostcodeLocationGet(security, postcode, options) {
        return (0, fp_js_1.unwrapAsync)((0, postcodesGetPostcodeLocationPostcodesPostcodeLocationGet_js_1.postcodesGetPostcodeLocationPostcodesPostcodeLocationGet)(this, security, postcode, options));
    }
    /**
     * Get Postcode Streetview Metadata
     *
     * @remarks
     * Get streetview metadata for each property within a postcode.
     */
    async getPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGet(security, postcode, options) {
        return (0, fp_js_1.unwrapAsync)((0, postcodesGetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGet_js_1.postcodesGetPostcodeStreetviewMetadataPostcodesPostcodeStreetviewMetadataGet)(this, security, postcode, options));
    }
}
exports.Postcodes = Postcodes;
//# sourceMappingURL=postcodes.js.map